export default __webpack_public_path__ + "static/media/file-type-jpg-icon.21c5f512.svg";